import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { withDefaults, computed } from "vue"
  import { Color, Size } from "./ALinhaDivisora.modelos"

  interface Props {
    color?: Color
    content?: string
    size?: Size
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ALinhaDivisora',
  props: {
    color: { default: "primary" },
    content: { default: "" },
    size: { default: "medium" }
  },
  setup(__props: any) {

const props = __props as { color: Color, content: string, size: Size }

  const definirClasseCssPorProps = computed(() => {
    return ["ALinhaDivisora--" + props.color, "ALinhaDivisora--" + props.size]
  })

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ALinhaDivisora", _unref(definirClasseCssPorProps)]),
    "data-testid": "a-linha-divisora"
  }, [
    _createElementVNode("span", null, _toDisplayString(props.content), 1)
  ], 2))
}
}

})